import React from "react";

export default function QuestionBox(props){
    return(
        <div className=" bg-white w-100% top-[500px]  p-3 m-1 md:m-4  text-lg rounded-sm">
        <div className="font-bold underline decoration-3 mb-2 ">Question</div>
        <p className="p-2 mb-3">{props.question} </p>
      </div>
    )
}